<template>
  <div id="app">
    <router-view />
    <Popup
      @close="handleClosePopup"
      animation="fade"
      :transparentBg="false"
      :fullsize="false"
      :hasBg="false"
      :borderRadiusBySide="['16px', '0', '0', '16px']"
      v-bind="{
        modalContainerStyles: defaultContainerStyle,
      }"
      :active="errorHandler.showPopup"
      size="PopupSize.small"
      :overlayClickable="false"
    >
      <template v-slot:errorMsg>
        <div class="errorText">
          <p>{{ $t(errorHandler.errorMessage) }}</p>
          <a class="touched clickable" @click.stop="handleClosePopup">{{ $t('Okey, got it.') }}</a>
        </div>
      </template>
    </Popup>
    <Transition>
      <div v-if="showBackDrop" class="video-backdrop" @click="updateAutoScale"></div>
    </Transition>
  </div>
</template>

<script>
import Vue from 'vue';
import { initMgConnection } from '@/utils/websocket';
import { mapGetters, mapActions } from 'vuex';
import Popup from '@/components/popup/index.vue';
import { isMobile } from 'mobile-device-detect';
import { ROUTE_NAME } from './utils/constant';

export default Vue.extend({
  name: 'App',
  components: {
    Popup,
  },
  created() {
    if (window.performance) {
      console.info('window.performance is supported');
    }
    const RELOAD_TYPE = ['navigate', 'reload', 'back_forward']; // performanceEntires
    const RELOAD_ENUM = [0, 1, 2]; // for deprecatedperformanceType
    const performanceEntires = performance.getEntriesByType('navigation');
    const deprecatedperformanceType = performance ? performance.navigation.type : '';
    if (RELOAD_TYPE.includes(performanceEntires[0].type) || RELOAD_ENUM.includes(deprecatedperformanceType)) {
      this.$router.onReady(() => {
        if ([ROUTE_NAME.cockFight, ROUTE_NAME.taiXiu].includes(this.$router.currentRoute.name)) {
          this.getOwnerTickets({
            isSeen: false,
          });
          initMgConnection(this.token, this.oddsType);
          Vue.i18n.set(this.config.language || 'en');
        }
      });
    }
  },
  data() {
    return {
      defaultContainerStyle: {
        position: 'relative',
        minWidth: '280px',
      },
    };
  },
  computed: {
    ...mapGetters('general', [
      'token',
      'errorHandler',
      'config',
      'videoAutoScale',
      'realBalance',
      'futureDiff',
      'oddsType',
    ]),
    ...mapGetters('fight', ['fight']),
    isMobileVertical() {
      return isMobile && this.$screen.width < this.$screen.height;
    },
    showBackDrop() {
      return !this.isMobileVertical && this.videoAutoScale && this.fight.status === 'started';
    },
  },
  methods: {
    ...mapActions('general', ['updateGeneral', 'updateBalance']),
    ...mapActions('jackpot', ['getOwnerTickets']),
    handleClosePopup() {
      const errorHandler = {
        errorMessage: '',
        showPopup: false,
      };
      this.updateGeneral({ errorHandler });
    },
    updateAutoScale() {
      this.updateGeneral({ videoAutoScale: false });
    },
  },
  watch: {
    futureDiff: {
      handler(newVal, oldVal) {
        if (!oldVal && newVal) {
          setTimeout(
            () =>
              this.updateBalance({
                value: this.realBalance,
                futureDiff: 0,
              }),
            2000
          );
        }
      },
      immediate: true,
    },
  },
});
</script>
<style lang="scss" scoped>
.errorText {
  padding: 0 32px 24px 32px;
  max-width: 310px;
  box-sizing: border-box;
  background-color: var(--bgSecondary);
  p {
    padding: 13px 32px;
    font-weight: 500;
    font-size: 14px;
    text-align: center;
    @include alignJustifyCenter;
    color: var(--txtSecondary);
  }
  .touched {
    display: block;
    padding: 1px 0;
    text-align: center;
    font-size: 16px;
    font-weight: 600;
    color: var(--txtMain);
    cursor: pointer;
    background-image: linear-gradient(90deg, var(--popularLineBgEnd) 0%, var(--popularLineBgStart) 100%);
    &:hover {
      background-image: linear-gradient(89deg, var(--placeBetBtnHoverStart) 100%, var(--placeBetBtnHoverEnd) 0%);
    }
  }
}
.video-backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 99;
  background-color: #000;
  opacity: 0.7;
}
</style>
